<template>
	<div>
		<button v-if="!Link" class="button is-default is-small" :class="{'is-loading': portfolio.loading }" @click="download()">Download</button>
		<a v-if="Link" style="border: none" :class="{'is-loading': portfolio.loading }" @click="download()">
			Download Certificate
		</a>

		<div v-if="portfolio.loading" style="display: none">
			<div :id="'certificate' + portfolio.Name">
				<div class="container">
					<div class="box">
						<div class="has-text-centered">
							<img class="banner-icon" style="max-width: 115px;" src="CC-Logo.png" />
							<h2>Certificate of portfolio annual CO2 emissions</h2>
							<h3>Portfolio Name: {{ portfolio.Name }}</h3>
							<p>Created on {{ $moment().format("DD MMMM, YYYY")}} for: {{ $store.getters.user.OrganizationName}}</p>
						</div>
						<br />
						<p>Aggregate annual CO2 emissions</p>
						<p class="has-text-centered"><span class="is-blue large-font">{{ portfolio.Emissions ? $math.format($math.round(portfolio.Emissions, 3)) : $math.format($math.round(portfolio.CarbonOutput, 3)) }}</span> tonnes</p>
						<p class="has-text-centered">Actuall emissions may vary, please see the <a>Calculation Methodology Document</a> for more details.</p>
						<br />
						<h3>Aircraft included in {{ portfolio.Name }} portfolio</h3>
						<br />
						<aircraftTable :Aircraft="portfolio.FullAircraft"
									   Name
									   Model
									   IsBlue></aircraftTable>
						<br />
						<p>The information contained in this certificate may only be utilised for the purposes prescribed in the <a>Terms of Use.</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		components: {
		},
		props: {
			Portfolio: {},
			Link: Boolean
		},
		data() {
			return {
				portfolio: {}
			}
		},
		methods: {
			setLoading(entity, loading) {
				this.$set(entity, 'loading', loading);
			},
			download() {

				this.setLoading(this.portfolio, true);

				this.$nextTick(async () => {
					setTimeout(async () => {
						var html = document.getElementById("certificate" + this.portfolio.Name).innerHTML;
						var resp = await this.$http({ method: 'post', url: 'api/print', data: { html: html, IsPortfolio: true }, responseType: 'arraybuffer' });
						let blob = new Blob([resp.data]);
						var link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.setAttribute('download', "".concat(this.portfolio.Name, " Emissions Certificate.pdf"));
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.$gtag.event("Portfolio Certificate Download", {
							'event_category': "Certificate Download",
							'event_label': "Portfolio Certificate Download"
						});
						this.setLoading(this.portfolio, false);
						this.$emit("complete");
					},
						1000);
				});

			}
		},
		mounted() {
			this.portfolio = this.Portfolio
			this.$http.get("api/portfolio/" + this.Portfolio.Id + "/aircraft")
				.then(resp => {
					this.$set(this.portfolio, 'FullAircraft', resp.data.Aircraft);
				})
		}

	}
</script>
